"use client";

import React, { useCallback } from 'react';
import styles from './_gc-step-clinical-options.module.scss';
import GcStepShell from '../../components/gc-step-shell';
import { GC_CALC_POPULATION, GC_CALC_STATUS } from '@/data/gc-calculator-data';

const ADULT_CLINICAL_BULLETS = [
  'Assess adherence to and accuracy of administration for both GC and CRENESSITY. Ensure patient is taking CRENESSITY with food',
  'Evaluate fludrocortisone dose',
  'Assess GC dose',
  'Review medications for CYP3A4 inducers',
  'Assess for any adverse events from treatment or GC withdrawal',
];

const getPediatricClinicalBullets = (isContinuing) => [
  'Assess adherence to and accuracy of administration for both GC and CRENESSITY. Ensure patient is taking CRENESSITY with food',
  `Check weight and ${isContinuing ? 'adjust' : 'increase'} CRENESSITY dose if indicated by weight`,
  'Evaluate fludrocortisone dose',
  'Assess GC dose',
  'Review medications for CYP3A4 inducers',
  'Assess for any adverse events from treatment or GC withdrawal',
];

/**
 * @description GC OPTIMIZE™ Calculator — Clinical Options
 * Pediatric: static bullet list for clinical interventions.
 * No inner steps — single screen with Save & continue.
 *
 * Saved fields (via dispatch):
 *   clinicalOptions — [] (step completion marker only)
 *
 * @param {Function} dispatch — wizard dispatch
 * @param {Function} onBack   — navigate to previous step
 * @param {Function} onNext   — navigate to next step
 */
function GcStepClinicalOptions({ state, dispatch, onBack, onNext, isReview, stepNumber }) {
  const handleSave = useCallback(() => {
    dispatch({ type: 'SET_FIELD', field: 'clinicalOptions', value: [] });
    onNext();
  }, [dispatch, onNext]);

  const isPediatric = state?.population === GC_CALC_POPULATION.PEDIATRIC;
  const isContinuing = state?.status === GC_CALC_STATUS.CONTINUING;
  const clinicalBullets = isPediatric ? getPediatricClinicalBullets(isContinuing) : ADULT_CLINICAL_BULLETS;

  return (
    <GcStepShell
      title="Clinical Options"
      showBack={false}
      onBack={onBack}
      onNext={handleSave}
      isReview={isReview}
      nextLabel="Save &amp; continue"
      nextVariant={['solid', 'solid--eggplant']}
      stepNumber={stepNumber}
    >
      <div className={styles.clinical_content}>
        <p className={styles.clinical_intro}>
          Assess treatment progress in ~1-3 months. Clinical assessment date for this patient is {state?.formValues?.clinicalAssessmentDate || state?.formValues?.assessLabDrawDate || '(not set)'}.
        </p>

        <ul className={styles.bullet_list}>
          {clinicalBullets.map((item) => (
            <li key={item}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </GcStepShell>
  );
}

export default GcStepClinicalOptions;
